import React, {useEffect, useRef, useState} from 'react';
import {Input, Popup} from "semantic-ui-react";
import ClearableInput from "../../components/Input/ClearableInput";

const TextFilter = ({filter, column, setFilter, type}) => {

    const changeFilter = (v) => {
        setFilter({
            fieldName: column.fieldName,
            operation: 'contains',
            value: v ? v : null
        })
    }

    const style = {
        border: '1px solid #135CA9',
        padding: '8px',
        borderRadius: '4px'
    }

    return (
        <Popup
            style={style}
            on='click'
            basic
            position='bottom left'
            pinned
            trigger={
                <ClearableInput
                    readOnly
                    icon={!(filter || {}).value && 'search'}
                    withSort={!column.disableSort}
                    sizer={false}
                    compact
                    placeholder={column.title}
                    value={(filter || {}).value || ''}
                    onChange={(e, {value}) => changeFilter(value)}
                />
            }
        >
            <Input
                type={type}
                autoFocus
                style={{width: '250px'}}
                icon='search'
                iconPosition='left'
                placeholder='Введите данные для поиска'
                value={(filter || {}).value || ''}
                onChange={(e, {value}) => changeFilter(value)}
            />
        </Popup>
    );
};

export default TextFilter;


// WEBPACK FOOTER //
// ./App/grids/filters/text.jsx